// components/HeroSlider.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { ArrowForward, ArrowBack } from '@mui/icons-material';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      title: 'Luxury Redefined',
      subtitle: 'Experience unparalleled comfort and sophistication',
      button: 'Explore Suites'
    },
    {
      image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      title: 'Gourmet Dining',
      subtitle: 'Award-winning cuisine in breathtaking settings',
      button: 'View Restaurants'
    },
    {
      image: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
      title: 'Wellness Oasis',
      subtitle: 'Rejuvenate your mind, body, and soul',
      button: 'Discover Spa'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <Box sx={{ position: 'relative', height: '80vh', overflow: 'hidden' }}>
      {slides.map((slide, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${slide.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: index === currentSlide ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(135deg, rgba(25,118,210,0.3) 0%, rgba(0,0,0,0.5) 100%)',
            }
          }}
        >
          <Container maxWidth="lg" sx={{ height: '100%', position: 'relative', zIndex: 1 }}>
            <Box sx={{ 
              height: '100%', 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: 'center',
              color: 'white',
              textAlign: 'left',
              maxWidth: '600px'
            }}>
              <Typography 
                variant="h2" 
                gutterBottom 
                fontWeight="bold"
                sx={{ 
                  textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                }}
              >
                {slide.title}
              </Typography>
              <Typography 
                variant="h5" 
                gutterBottom 
                sx={{ 
                  mb: 4,
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                }}
              >
                {slide.subtitle}
              </Typography>
              <Button 
                variant="contained" 
                size="large"
                endIcon={<ArrowForward />}
                sx={{ 
                  borderRadius: '25px',
                  px: 4,
                  py: 1.5,
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                }}
              >
                {slide.button}
              </Button>
            </Box>
          </Container>
        </Box>
      ))}

      {/* Navigation Arrows */}
      <Button
        onClick={prevSlide}
        sx={{
          position: 'absolute',
          left: 20,
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'white',
          bgcolor: 'rgba(255,255,255,0.2)',
          '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
        }}
      >
        <ArrowBack />
      </Button>
      <Button
        onClick={nextSlide}
        sx={{
          position: 'absolute',
          right: 20,
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'white',
          bgcolor: 'rgba(255,255,255,0.2)',
          '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' }
        }}
      >
        <ArrowForward />
      </Button>

      {/* Slide Indicators */}
      <Box sx={{ 
        position: 'absolute', 
        bottom: 20, 
        left: '50%', 
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: 1
      }}>
        {slides.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentSlide(index)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              bgcolor: index === currentSlide ? 'primary.main' : 'rgba(255,255,255,0.5)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default HeroSlider;